export default __webpack_public_path__ + "static/media/miradore.26da4f51.svg";